// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1XjBP","info":"UpdateTermsInfo_info__GCjhI"};